'use strict';
const angular = require('angular');

/*@ngInject*/
export function appIconCheckFilter() {
  return function(input) {
    return (input !== '' && input !== undefined) ? input : '/assets/images/app.png';
  };
}


export default angular.module('updateServerApp.appIconCheck', [])
  .filter('appIconCheck', appIconCheckFilter)
  .name;



// WEBPACK FOOTER //
// ./client/app/filters/app-icon-check.filter.js